module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }